const PAGES = Object.freeze({
	SINGLE_PAGE: 'GroupSinglePageRecord',
	SINGLE_HOW_WE_WORK_PAGE_NEW: 'CommonHowWeWorkPageRecord',
	DESIGN_SINGLE_PROJECT: 'DesignSingleProjectRecord',
	DIGITAL_SINGLE_PAGE: 'DigitalSinglePageRecord',
	DIGITAL_SINGLE_PROJECT: 'DigitalSingleProjectRecord',
	DIGITAL_ALL_PROJECTS_PAGE: 'DigitalAllProjectsPageRecord',
	DIGITAL_SINGLE_HOW_WE_WORK_PAGE: 'DigitalSingleHowWeWorkPageRecord',
});

const TYPES = Object.freeze({
	PAGES,
	MARGIN: 'MarginRecord',
	ALL_NEWS_PRESENTATION: 'GroupAllNewsPresentationRecord',
});

export default TYPES;
